import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Outcome } from '../../models/outcomes/Outcome';
import { ValidationService } from 'src/app/services/validation.service';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';

@Component({
  selector: 'app-add-outcome-modal',
  templateUrl: './add-outcome-modal.page.html',
  styleUrls: ['./add-outcome-modal.page.scss'],
})
export class AddOutcomeModalPage implements OnInit {

  public outcome: Outcome = new Outcome();
  public isEditing = false;
  public isGroup = true;
  public minDate = new Date().toISOString();

  constructor(
    public modalController: ModalController,
    public validationService: ValidationService,
    public unfocusService: UnfocusElementService
  ) { }

  ngOnInit() {
    if(!this.isEditing){
      this.outcome.credits = 0;
    }
  }

  closeModal() {
    this.modalController.dismiss();
  }

  setNegativeToZero(event) {
    console.log(Number(event.target.value));
    if (Number(event.target.value) < 0) {
      event.target.value = 0;
    }else{
      event.target.value = Number(event.target.value);
    }
  }

  saveOutcome(event) {
    this.unfocusService.unfocus(event);
    this.outcome.title = this.validationService.removeHtmlTags(this.outcome.title);
    this.outcome.isGroup = this.isGroup;
    if (this.validationService.isOutcomeValid(this.outcome)) {
      if (!this.validationService.checkOutcomeVariableLengths(this.outcome)) {
        if (!this.outcome.credits) {
          this.outcome.credits = 0;
        }
        this.modalController.dismiss(this.outcome);
      }
      else {
        this.validationService.alertForOutcomePropertiesTooLong(this.outcome);
      }
    } else {
      //this.validationService.alertForMissingOutcomeProperties(this.outcome);
    }

  }
}

